import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core'
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { tap } from 'rxjs/operators'
import { UuidFormValidator, isValidUUID } from '@helios/validators'

@Component({
  selector: 'hs-filter-group-import-button',
  templateUrl: './filter-group-import-button.component.html',
})
export class FilterGroupImportButtonComponent {
  @ViewChild('fetchPopover') popover?: NgbPopover

  @Output() createFromFilterGroupPrefix = new EventEmitter<string>()

  readonly filterGroupPrefix = new FormControl('', [Validators.required])

  readonly popoverForm = new FormGroup({
    filterGroupPrefix: this.filterGroupPrefix,
  })

  onPopoverSubmit() {
    this.createFromFilterGroupPrefix.emit(this.filterGroupPrefix.value)

    this.popoverForm.reset()
    this.popover?.close()
  }
}
